import styled from '@emotion/styled';
import type { ComponentProps } from 'react';
import LogoMark from 'storybookConfig/stories/molecules/Logo';
import { ThemeBreakpoints } from 'storybookConfig/stories/theme';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  width: 100%;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.color.bodyBackground};

  @media screen and (${ThemeBreakpoints.md}) {
    padding: 48px;
  }
`;

interface ContentProps {
  $width?: string;
  $maxWidth?: string;
}

const Content = styled.div<ContentProps>`
  width: ${({ $width = 'auto' }) => $width};
  max-width: ${({ $maxWidth }) => $maxWidth};
`;

/** The wordmark, in the text colour around it. */
const Logo = styled((props: ComponentProps<'div'>) => (
  <div {...props}>
    <LogoMark />
  </div>
))`
  font-size: 24px;
  color: ${({ theme }) => theme.color.bodyTextPrimary};
`;

/**
 * Layout is a basic layout component that can be used to wrap content in a page.
 * It provides a consistent padding and background, and not much else.
 * It's meant to be composed by more specific layout components.
 */
const Layout = {
  Root,
  Content,
  Logo,
};

export default Layout;
